import React, { useCallback, useState } from "react";
import axiosInstance from "./base/axios";

const PostHooks = () => {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState();

  const callApi = useCallback(async (pro) => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(pro.url, pro.body);
      setData(res);
      return res;
    } catch (err) {
      setData(err);
      console.log(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return [isLoading, data, callApi];
};

export default PostHooks;
